module.exports = __webpack_public_path__ + "images/chevron-down-v2-c441b42b559c517ef9904e2a7eb0175a.svg";